import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import { ReactSVG } from 'react-svg';
import { addMessage, bonoBotState, setChatInput } from 'store/bonoBot/bonoBot.slice';
import { GeneralExampleType } from 'store/bonoBot/types';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useSocketInstanceContext } from 'context/socketInstanceContext';

const GeneralExample: React.FC<GeneralExampleType> = ({ icon, title, action }) => {
   const dispatch = useAppDispatch();
   const { sendMessageToServer } = useSocketInstanceContext();
   const { charitiesList, selectedCharities } = useAppSelector(bonoBotState);

   const [exampleActionWasUsed, setExampleActionWasUsed] = useState(false);
   const sendMessageCallback = (message: string) => {
      dispatch(addMessage({ role: 'user', text: message }));
      dispatch(setChatInput(''));
   };

   const lastAddedCharity = action === 'showNextCharity' ? selectedCharities[selectedCharities.length - 1] : null;
   const indexOfLastAddedCharity = charitiesList?.findIndex((ch) => ch.id === lastAddedCharity?.id) ?? -1;
   const indexOfNextCharityToShow =
      indexOfLastAddedCharity !== -1 && indexOfLastAddedCharity + 1 < charitiesList.length
         ? indexOfLastAddedCharity + 1
         : -1;

   const handleClick = () => {
      setExampleActionWasUsed(true);
   };

   if (exampleActionWasUsed || (action === 'showNextCharity' && indexOfNextCharityToShow === -1)) return null;
   return (
      <Box onClick={handleClick} sx={{ flex: 1, cursor: 'pointer', py: 1, px: 1.5 }}>
         <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', columnGap: '8px' }}>
            {icon && (
               <ReactSVG
                  src={`data:image/svg+xml;utf8,${encodeURIComponent(icon)}`}
                  beforeInjection={(svg) => {
                     svg.querySelectorAll('path').forEach((path) => {
                        path.setAttribute('fill', '#333333');
                     });
                     svg.setAttribute('width', '24');
                     svg.setAttribute('height', '24');
                  }}
                  style={{ width: '24px', height: '24px' }}
               />
            )}
            <Typography
               sx={{
                  color: '#999999',
                  fontSize: '13px',
                  fontWeight: 600,
                  lineHeight: '16px',
               }}
            >
               {title}
            </Typography>
         </Box>
      </Box>
   );
};

export default GeneralExample;
